function isRetryableError(error) {
  if (error?.response) return error.response.status >= 500;
  if (error?.code && ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error.code)) return true;
  return error?.message === 'Network Error';
}

function wait(delayMs) {
  return new Promise(resolve => setTimeout(resolve, delayMs));
}

export async function retryRequest(request, { attempts = 2, delayMs = 1000 } = {}) {
  let lastError;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      return await request();
    } catch (error) {
      lastError = error;
      if (attempt === attempts - 1 || !isRetryableError(error)) throw error;
      await wait(delayMs);
    }
  }

  throw lastError;
}
